module.exports = __webpack_public_path__ + "media/unipod/mechanical_services_1-23685c6c.jpg";